import { FlagType } from '~/flags/flags';
import { useFlag } from '~/flags/useFlag';
import { api } from '~/redux/api/createApi';
import { Dashboard } from '~/redux/api/methods/dashboardV2';
import { Chart } from '~/types/DashboardV2';

interface Props {
  entity?: Dashboard['entity'];
  id: Chart['id'];
  filterType: Chart['filterType'];
  query: any[];
  interval?: string;
}

export function useGetChartData({
  entity,
  id,
  filterType,
  query,
  interval,
}: Props) {
  const hasDeprecatePilotSearch = useFlag(FlagType.DeprecatePilotSearch);
  const shouldUseV2Endpoint =
    entity === 'ticket' || entity === 'workflow' || hasDeprecatePilotSearch;

  const bucket_size = filterType === 'date' ? 12 : 10;

  const endpoint = shouldUseV2Endpoint ? 'getChartDataV2' : 'getChartData';

  const response = api.endpoints[endpoint].useQuery({
    uuid: id,
    query,
    bucket_size,
    entity,
    interval,
  });

  return {
    ...response,
  };
}
